import { t } from '@/plugins/i18n';
import { RouteName } from '../constants/routeNames';

export const unauthorizedRoutes = [
  {
    path: '',
    name: RouteName.Home,
    component: () => import('../../views/HomePage.vue'),
    meta: { title: t('message.login') }
  },
  {
    path: '/forgot-password',
    name: RouteName.ForgotPassword,
    component: () => import('../../views/ForgotPassword.vue'),
    meta: { title: t('user.passwordForgotten') }
  },
  {
    path: '/reset-password',
    name: RouteName.ResetPassword,
    component: () => import('../../views/ResetPassword.vue'),
    meta: { title: t('reset.title') }
  },
  {
    path: '/activation',
    name: RouteName.Activate,
    component: () => import('../../views/UserActivation.vue'),
    meta: { title: t('activation.title') }
  },
  {
    path: '/initial-login',
    name: RouteName.InitialLogin,
    component: () => import('../../views/InitialLogin.vue'),
    meta: { title: t('user.initialLogin') }
  },
  {
    path: '/register',
    name: RouteName.Registration,
    component: () => import('../../views/RegistrationPage.vue'),
    meta: { title: t('register.title') }
  }
];

export function isUnauthorizedRoute(routeName: string): boolean {
  return unauthorizedRoutes.some((route) => route.name === routeName);
}
